import icon from 'assets/icons/table-chart.svg';
import React, { Component, PureComponent } from 'react';
import { ResponsiveContainer, Tooltip, Treemap } from 'recharts';
import './RiskAsset.style.scss';
import { get } from 'lodash';
import { nFormatter } from '../../../../utils';

export default class RiskAsset extends Component {
  render() {
    const data = get(this.props.data, 'in_icaap', []).filter((item) =>
      ['RWACR', 'RWAOR', 'RWAMR', 'RWACOR', 'RWAIRRBB', 'RWAOMR'].includes(item.items)
    );

    const COLORS = ['#A07E20', '#FBC83A', '#C89404', '#FDE39B'];
    return (
      <div className='risk-container'>
        <h1 className='risk-title'>
          <img src={icon} alt='' style={{ marginRight: 8 }} />
          RISK WEIGHTED ASSET
        </h1>
        <ResponsiveContainer width='100%' height={170}>
          <Treemap data={data} dataKey='t0_bau' content={<CustomizedContent colors={COLORS} />}>
            <Tooltip cursor={false} content={<CustomTooltip data={data} colors={COLORS} />} />
          </Treemap>
        </ResponsiveContainer>
      </div>
    );
  }
}
class CustomizedContent extends PureComponent {
  render() {
    const { x, y, width, height, index, colors, items } = this.props;

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: colors[index % colors.length],
            stroke: '#fff',
            strokeWidth: 1,
          }}
          rx={4}
        />

        <text
          x={x + 8}
          y={y + height / 2 + 7}
          textAnchor='start'
          fill='#000000'
          fontSize={14}
          fontWeight={600}>
          {items}
        </text>
      </g>
    );
  }
}

const CustomTooltip = (props) => {
  const { active, payload, data, colors } = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;
    const index = data.findIndex((el) => el.key === item.key);

    return (
      <div className='custom-tooltip' style={{ backgroundColor: colors[index % data.length] }}>
        <span className='name'>{item.items}</span>
        <span className='desc'>{nFormatter(item.t0_bau)}</span>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/RiskAsset/RiskAsset.js